import { createSelector } from 'reselect'

/**
 * Select the engage state slice
 * @param {object} state - Redux state
 * @returns {object} Engage state
 */
export const selectEngage = (state) => state.engage

/**
 * Select filtered engagements
 * @param {object} state - Redux state
 * @returns {Array} Filtered engagements
 */
export const selectFilteredEngagements = createSelector(
  selectEngage,
  (engage) => engage.filteredEngagements
)

/**
 * Select engagement breadcrumbs
 * @param {object} state - Redux state
 * @returns {Array} Breadcrumbs
 */
export const selectBreadcrumbs = createSelector(
  selectEngage,
  (engage) => engage.breadcrumbs
)

/**
 * Select the engagement detail ID
 * @param {object} state - Redux state
 * @returns {string|null} Engagement detail ID
 */
export const selectEngageDetailId = createSelector(
  selectEngage,
  (engage) => engage.detailId
)

/**
 * Select the reply GUID
 * @param {object} state - Redux state
 * @returns {string|null} Reply GUID
 */
export const selectReplyGuid = createSelector(
  selectEngage,
  (engage) => engage.replyGuid
)

/**
 * Select whether engagement navigation is pending
 * @param {object} state - Redux state
 * @returns {boolean} Navigation pending status
 */
export const selectShouldNavigate = createSelector(
  selectEngage,
  (engage) => engage.shouldNavigate
)
